"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.standardTokenNames = exports.builtInParamNames = exports.PARAM_SP_HOST_URL = void 0;
var PARAM_SP_HOST_URL = exports.PARAM_SP_HOST_URL = 'SPHostUrl';
var standardTokenNames = exports.standardTokenNames = [PARAM_SP_HOST_URL, 'SPLanguage', 'SPClientTag', 'SPProductNumber', 'SPAppWebUrl'];
var builtInParamNames = exports.builtInParamNames = [].concat(standardTokenNames, ['AppOnly', 'FVAnon']);